declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FacilityDetailInfoController, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController } from '../../../../../../src/app/ncs/models/actor/actor';
import { FacilityDetailInfoRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { ConsumptionEntrypipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';



@Component({
  selector: 'printlayoutRXA5',
  templateUrl: './printlayoutRXA5.component.html',
  styleUrls: ['./printlayoutRXA5.component.css']
})

export class  printlayoutRXA5Component implements OnInit {

  //@Input() FormattedCode: string;
  public Date: Date;
  public ApiResData: ApiResponseModel;

  public RXHeaderFooterLine1: string = "";
  public RXHeaderFooterLine2: string = "";
  public RXHeaderFooterLine3: string = "";
  public RXHeaderFooterLine4: string = "";

  public RXHeaderSubTitle1: string = "";
  public RXHeaderSubTitle2: string = "";
  public RXHeaderSubTitle1Value: string = "";
  public RXHeaderSubTitle2Value: string = "";

  public RXlogo: string = "";
  public RXHeaderLine1: string = "";
  public RXHeaderLine2: string = "";
  public GST: string;
  public DL: string;
  public PatientId: any;
  public Branchname: string;
  public BillNumber: any;
  public ChargeEntryCode: any;
  public PrintlogoWidth: number;
  public PrintlogoHeight: number;
  public PrintlogoBorderRadius: number;
  public RXA5width: number;

  public isRequesting: boolean = false;

  RXPrintHeaderHeight: number = 165;
  ShowRXPrintFooter: string = "true";
  ShowRXPrintFooterEmpty: string = "false";
  RXPrintFooterHeight: number = 150;

  ShowRXPrintHeaderLogoCustomer: string = "true";
  ShowRXPrintHeaderLogo: string = "false";
  RXPrintHeaderEmpty: string = "false";
  DmFont: string = "normal normal 12px courier, arial";
  RXDmFont: string = "normal normal 14px Sans Serif, Script";
  public RXMarginLayoutLeft: number;
  public RXMarginLayoutRight: number;
  public RXMarginLayoutTop: number;
  public RXMarginLayoutBottom: number;
 
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    public printService: PrintService,
    private route: ActivatedRoute,
    private filter: ConsumptionEntrypipe, private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter, ) {
    //this.myAngularxQrCode = 'this.FormattedCode';
  }


  ngOnInit() {

    this.PatientId = this.printService.GetCode();
    this.BillNumber = this.printService.GetBillNumber();
    this.ChargeEntryCode = this.printService.GetChargeEntryCode();
    this.RXHeaderFooterLine1 = AppData.Instance().cas.RXHeaderFooterLine1;
    this.RXHeaderFooterLine2 = AppData.Instance().cas.RXHeaderFooterLine2;
    this.RXHeaderFooterLine3 = AppData.Instance().cas.RXHeaderFooterLine3;
    this.RXHeaderFooterLine4 = AppData.Instance().cas.RXHeaderFooterLine4;
    this.Date = new Date();
    this.RXlogo = AppData.Instance().cas.RXlogo;
    this.PrintlogoWidth = AppData.Instance().cas.PrintlogoWidth;
    this.PrintlogoHeight = AppData.Instance().cas.PrintlogoHeight;
    this.PrintlogoBorderRadius = AppData.Instance().cas.PrintlogoBorderRadius;
    this.RXHeaderLine1 = AppData.Instance().cas.RXHeaderLine1;
    this.RXHeaderLine2 = AppData.Instance().cas.RXHeaderLine2;


    this.RXPrintHeaderHeight = AppData.Instance().cas.RXPrintHeaderHeight;
    this.ShowRXPrintFooter = AppData.Instance().cas.ShowRXPrintFooter;
    this.ShowRXPrintFooterEmpty = AppData.Instance().cas.ShowRXPrintFooterEmpty;
    this.RXPrintFooterHeight = AppData.Instance().cas.RXPrintFooterHeight;

    this.ShowRXPrintHeaderLogoCustomer = AppData.Instance().cas.ShowRXPrintHeaderLogoCustomer;
    this.ShowRXPrintHeaderLogo = AppData.Instance().cas.ShowRXPrintHeaderLogo;
    this.RXPrintHeaderEmpty = AppData.Instance().cas.RXPrintHeaderEmpty;
    this.DmFont = AppData.Instance().cas.DmFont;

    this.LoadBillHeader();
    this.GST = AppData.Instance().GetDataParam('TinNo');
    this.DL = AppData.Instance().GetDataParam('DrugLicenceNo');
    this.RXHeaderSubTitle1 = AppData.Instance().cas.RXHeaderSubTitle1;
    this.RXHeaderSubTitle2 = AppData.Instance().cas.RXHeaderSubTitle2;
    this.RXHeaderSubTitle1Value = AppData.Instance().cas.RXHeaderSubTitle1Value;
    this.RXHeaderSubTitle2Value = AppData.Instance().cas.RXHeaderSubTitle2Value;
    this.Branchname = AppData.Instance().SelectedBranchName;
    this.RXMarginLayoutLeft = AppData.Instance().cas.RXMarginLayoutLeft;
    this.RXMarginLayoutRight = AppData.Instance().cas.RXMarginLayoutRight;
    this.RXMarginLayoutTop = AppData.Instance().cas.RXMarginLayoutTop;
    this.RXMarginLayoutBottom = AppData.Instance().cas.RXMarginLayoutBottom;
    this.RXA5width = AppData.Instance().cas.RXA5width;
    this.RXDmFont = AppData.Instance().cas.RXDmFont;
  }

  CurrentX_BillHeaderController: X_BillHeaderController;
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    this.CurrentX_BillHeaderRequest.ChargeEntry = this.ChargeEntryCode;
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

 
 
 


 
}
